export function createSectionsState(instructions) {

  return instructions.map((section, index) => {
    const state = {
      id: section.id,
      isCollapsed: true,
      selectedStep: null
    };

    // expand the first section by default
    if (index === 0) {
      state.isCollapsed = false
      state.selectedStep = 0
    }
  
    return state
  })
}